



















































import { userModule } from "@/store/modules/user";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeSoap } from "@/store/modules/soap";
import SuketKematian from "@/store/modules/SuketKematian";
import SuketKematianTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketKematianTabPage.vue";
import { storeSpri } from "@/store/modules/spri";
import CardSPRI from "@/components/pemeriksaan/resumeSuketV2/CardSPRI.vue";
import { storeSkDiagnosa } from "@/store/modules/skdiagnosa";
import SuketIstirahat from "@/store/modules/SuketIstirahat";
import CardSKIstirahat from "@/components/pemeriksaan/resumeSuketV2/CardSKIstirahat.vue";
import CardDiagnosa from "@/components/pemeriksaan/resumeSuketV2/CardDiagnosa.vue";
import SuketSehatJasmani from "@/store/modules/SuketSehatJasmani";
import CardSKSehatJasmani from "@/components/pemeriksaan/resumeSuketV2/CardSKSehatJasmani.vue";
import SuketDirawat from "@/store/modules/SuketDirawat";
import SuketDirawatTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketDirawatTabPage.vue";
import { storeVisumEtRepertum } from "@/store/modules/VisumEtRepertumStore";
import CardVisumEtRepertum from "@/components/pemeriksaan/tabs/surat-keterangan/visum/CardVisumEtRepertum.vue";
import storeICT from "@/store/modules/InformedConsentTindakanStore";
import CardInformedConsentTindakan from "@/components/pemeriksaan/tabs/persetujuan/CardInformedConsentTindakan.vue";
import storeCutiBersalin from "@/store/modules/SuratCutiBersalinStore";
import CardSuratCutiBersalin from "@/components/pemeriksaan/tabs/surat-keterangan/CardSuratCutiBersalin.vue";
import SuketDisabilitas from "@/store/modules/SuketDisabilitas";
import SuketDisabilitasTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/SuketDisabilitasTabPage.vue";
import SuketForm77TabPage from "@/components/pemeriksaan/tabs/surat-keterangan/SuketForm77TabPage.vue";
import { storeSuratKeteranganKelahiran } from "@/store/modules/SuratKeteranganKelahiranStore";
import SuratKeteranganKelahiranList from "@/components/SuratKeteranganKelahiran/SuratKeteranganKelahiranList.vue";
import SuketPenanggungjawabBayi from "@/store/modules/SuketPenanggungjawabBayi";
import SuketPenanggungjawabBayiTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketPenanggungjawabBayiTabPage.vue";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";
import SuketIndex, {
  SuketTabSource,
  bySuket,
  byRegister,
  childFetches
} from "@/services/SuketIndex";

const SUKET_TAB_SOURCE: Record<string, SuketTabSource> = {
  "tab-spri": { key: "spri", fetch: r => storeSpri.act_spri_on_reg(r) },
  "tab-sk-kematian": bySuket("kematian", SuketKematian),
  "tab-diagnosa": childFetches("suket-diagnosa"),
  "tab-istirahat": bySuket("suket-istirahat", SuketIstirahat),
  "tab-sehat": bySuket("suket-sehat-jasmani", SuketSehatJasmani),
  "tab-suket-dirawat": bySuket("dirawat", SuketDirawat),
  "tab-visum": byRegister("visum-et-repertum", storeVisumEtRepertum),
  "tab-informed-consent-tindakan": byRegister(
    "informed-consent-tindakan",
    storeICT
  ),
  "tab-cuti-bersalin": childFetches("surat-cuti-bersalin"),
  "tab-sk-disabilitas": bySuket("disabilitas", SuketDisabilitas),
  "tab-surat-keterangan-kelahiran": byRegister(
    "surat-keterangan-kelahiran",
    storeSuratKeteranganKelahiran
  ),
  "tab-penanggungjawab-bayi": bySuket(
    "penanggungjawab-bayi",
    SuketPenanggungjawabBayi
  )
};

@Component({
  components: {
    SuketKematianTabPage,
    CardSPRI,
    CardSKIstirahat,
    CardSKSehatJasmani,
    CardDiagnosa,
    SuketDirawatTabPage,
    CardVisumEtRepertum,
    CardInformedConsentTindakan,
    CardSuratCutiBersalin,
    SuketDisabilitasTabPage,
    SuketForm77TabPage,
    SuratKeteranganKelahiranList,
    SuketPenanggungjawabBayiTabPage
  }
})
export default class CardSuket extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() dtResume!: object;
  @Prop({ default: null }) deepLink!: any;

  // Deep link from the universal form search on PasienFlyingBar (guarded by topTab).
  @Watch("deepLink", { immediate: true })
  onDeepLink(payload: any) {
    if (!payload || payload.topTab !== "tab-suket" || !payload.elemId) {
      return;
    }
    this.$nextTick(() => {
      this.tab = payload.elemId;
    });
  }

  modalSpri: boolean;
  sess_login = this.stateuser;
  tab = "";
  modalTambahSpri = false;
  pageTab = "tab-soap";
  expandInput = false;

  suketIndex: Record<string, number> = {};
  loadedTabs: Record<string, boolean> = {};

  mounted() {
    this.tab = "tab-spri";

    SuketIndex.getByRegister(this.register).then(map => {
      this.suketIndex = map;
    });

    this.loadTab(this.tab);
  }

  @Watch("tab")
  onTabChange(val: string) {
    this.loadTab(val);
    this.$nextTick(() => scrollTabIntoView(this.$el));
  }

  loadTab(val: string) {
    const src = val && !this.loadedTabs[val] && SUKET_TAB_SOURCE[val];
    if (!src) {
      return;
    }

    this.$set(this.loadedTabs, val, true);

    if (src.fetch) {
      src.fetch(this.register);
    }
  }

  hasSurat(tab: any): boolean {
    const src = SUKET_TAB_SOURCE[tab.val];
    if (!src) {
      return !!tab.data;
    }
    return this.loadedTabs[tab.val] ? !!tab.data : !!this.suketIndex[src.key];
  }

  get tabSuket() {
    const items = [
      {
        val: "tab-spri",
        loading: storeSpri.loading,
        iconText: "mdi-bed-outline",
        title: "Surat Perintah Rawat Inap",
        data: storeSpri.spri.length,
        component: "CardSPRI"
      },
      {
        val: "tab-sk-kematian",
        loading: SuketKematian.loading,
        iconText: "mdi-skull",
        title: "Surat Keterangan Kematian",
        data: SuketKematian.suket,
        component: "SuketKematianTabPage"
      },
      {
        val: "tab-diagnosa",
        loading: storeSkDiagnosa.loading,
        iconText: "mdi-stethoscope",
        title: "Surat Keterangan Diagnosa",
        data: storeSkDiagnosa.skDiagnosa.length,
        component: "CardDiagnosa"
      },
      {
        val: "tab-istirahat",
        loading: SuketIstirahat.loading,
        iconText: "mdi-sleep",
        title: "Surat Keterangan Istirahat",
        data: SuketIstirahat.suket.length,
        component: "CardSKIstirahat"
      },
      {
        val: "tab-sehat",
        loading: SuketSehatJasmani.loading,
        iconText: "mdi-clipboard-pulse-outline",
        title: "Surat Keterangan Dokter",
        data: SuketSehatJasmani.suket.length,
        component: "CardSKSehatJasmani"
      },
      {
        val: "tab-suket-dirawat",
        loading: SuketDirawat.loading,
        iconText: "mdi-stethoscope",
        title: "Surat Keterangan Dirawat",
        data: SuketDirawat.suket,
        component: "SuketDirawatTabPage"
      },
      {
        val: "tab-visum",
        loading: storeVisumEtRepertum.loading,
        iconText: "mdi-scale-balance",
        title: "Visum et Repertum",
        data: storeVisumEtRepertum.listVisum.length,
        component: "CardVisumEtRepertum"
      },
      {
        val: "tab-informed-consent-tindakan",
        loading: storeICT.loading,
        iconText: "mdi-file-document-edit",
        title: "Informed Consent Tindakan",
        data: storeICT.items.length,
        component: "CardInformedConsentTindakan"
      },
      {
        val: "tab-cuti-bersalin",
        loading: storeCutiBersalin.loading,
        iconText: "mdi-baby-face-outline",
        title: "Surat Keterangan Cuti Bersalin",
        data: storeCutiBersalin.items.length,
        component: "CardSuratCutiBersalin"
      },
      {
        val: "tab-sk-disabilitas",
        loading: SuketDisabilitas.loading,
        iconText: "mdi-wheelchair-accessibility",
        title: "Surat Keterangan Disabilitas",
        data: 0,
        component: "SuketDisabilitasTabPage"
      },
      {
        val: "tab-surat-keterangan-kelahiran",
        loading: storeSuratKeteranganKelahiran.loading,
        iconText: "mdi-baby-carriage",
        title: "Surat Keterangan Kelahiran",
        data: storeSuratKeteranganKelahiran.items.length,
        component: "SuratKeteranganKelahiranList"
      },
      {
        val: "tab-penanggungjawab-bayi",
        loading: SuketPenanggungjawabBayi.loading,
        iconText: "mdi-account-child-outline",
        title: "Surat Pernyataan Penanggungjawab Bayi",
        data: SuketPenanggungjawabBayi.suket ? 1 : 0,
        component: "SuketPenanggungjawabBayiTabPage"
      }
    ];

    return items;
  }

  get stateuser() {
    return userModule.user;
  }
  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  showTab(item) {
    // this.tabs=item
    this.tab = item;
    this.$emit("pageTab", item);
    // this.respResumes=item
    // console.log('1resr ',item)
  }
  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }
}
